var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('Feedback',{attrs:{"feedback":_vm.feedback,"dismissible":true}}),(_vm.btnRequirementsMet)?_c('b-button',{staticClass:"w-100",attrs:{"disabled":_vm.isDisabled,"variant":"primary"},on:{"click":_vm.handleGenerateViews}},[_vm._v(" Genereer aanzichten ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }